export const frequencies = {
  everyDay: {
    key: "everyDay",
    label: "Every day"
  },
  daysOfWeek: {
    key: "daysOfWeek",
    label: "Select days of the week"
  },
  daysInterval: {
    key: "daysInterval",
    label: "Select days interval"
  }
};

export const daysIntervals = {
  every2Days: {
    key: "every2Days",
    label: "Every 2 days",
    intervalDays: 2
  },
  every3Days: {
    key: "every3Days",
    label: "Every 3 days",
    intervalDays: 3
  },
  "1timePerWeek": {
    key: "1timePerWeek",
    label: "1 time per week",
    intervalDays: 7
  },
  everyTwoWeeks: {
    key: "everyTwoWeeks",
    label: "Every two weeks",
    intervalDays: 14
  },
  every3Weeks: {
    key: "every3Weeks",
    label: "Every 3 weeks",
    intervalDays: 21
  },
  every28Days: {
    key: "every28Days",
    label: "Every 28 days",
    intervalDays: 28
  },
  every30Days: {
    key: "every30Days",
    label: "Every 30 days",
    intervalDays: 30
  }
};

export const timesPerDayOptions = {
  "1TimePerDay": {
    key: "1TimePerDay",
    label: "1 time per day",
    initialTimes: ["08:00"]
  },
  "2TimesPerDay": {
    key: "2TimesPerDay",
    label: "2 times per day",
    initialTimes: ["08:00", "20:00"]
  },
  "3TimesPerDay": {
    key: "3TimesPerDay",
    label: "3 times per day",
    initialTimes: ["08:00", "14:00", "20:00"]
  },
  "4TimesPerDay": {
    key: "4TimesPerDay",
    label: "4 times per day",
    initialTimes: ["08:00", "12:00", "16:00", "20:00"]
  },
  "5TimesPerDay": {
    key: "5TimesPerDay",
    label: "5 times per day",
    initialTimes: ["08:00", "11:00", "14:00", "17:00", "20:00"]
  },
  "6TimesPerDay": {
    key: "6TimesPerDay",
    label: "6 times per day",
    initialTimes: ["08:00", "11:00", "14:00", "17:00", "20:00", "23:00"]
  },
  "7TimesPerDay": {
    key: "7TimesPerDay",
    label: "7 times per day",
    initialTimes: [
      "05:00",
      "08:00",
      "11:00",
      "14:00",
      "17:00",
      "20:00",
      "23:00"
    ]
  },
  "8TimesPerDay": {
    key: "8TimesPerDay",
    label: "8 times per day",
    initialTimes: [
      "02:00",
      "05:00",
      "08:00",
      "11:00",
      "14:00",
      "17:00",
      "20:00",
      "23:00"
    ]
  }
};

let times = [];
let startTime = 0;
const endTime = 23.75;
const step = 0.25;
while (startTime <= endTime) {
  let timeStr = "";

  if (startTime < 10) timeStr = "0";
  timeStr += Math.floor(startTime) + ":";

  const decimal = startTime - Math.floor(startTime);
  const minutes = 60 * decimal;
  if (minutes < 10) timeStr += "0";
  timeStr += minutes;

  times.push(timeStr);
  startTime += step;
}

export const timeOptions = times;
